import React from 'react';
import PropTypes from 'prop-types';

import {Menu, MenuList, MenuItem} from '@mui/material';
import {Link} from 'react-router-dom';
import {Popper} from 'views/components';

const MenuItemLink = (props) => {
  const {href, ...restOfProps} = props;

  return (
    <MenuItem component={Link} to={href} {...restOfProps} />
  );
};
MenuItemLink.propTypes = {
  href: PropTypes.string.isRequired,
};

const MenuMemo = React.memo(Menu);
const MenuItemMemo = React.memo(MenuItem);
const MenuItemLinkMemo = React.memo(MenuItemLink);


const PopperMenu = (props) => {
  const {
    options,
    onMenuItemClick,
    selectedIndex,
  } = props;

  return (
    <Popper {...props}>
      <MenuList autoFocusItem>
        {
          options.map((option, index) => (
            <MenuItem
              key={index}
              selected={index === selectedIndex}
              onClick={(event) => onMenuItemClick(event, index)}
            >
              {option.text}
            </MenuItem>
          ))
        }
      </MenuList>
    </Popper>
  );
};
PopperMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.any.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  open: PropTypes.bool.isRequired,
  onClickAway: PropTypes.func.isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  anchorEl: PropTypes.any,
};

export {
  MenuMemo as Menu,
  MenuItemMemo as MenuItem,
  MenuItemLinkMemo as MenuItemLink,
  PopperMenu,
};
